module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.activePanel) ? _c('div', {
    staticClass: "sideways-content-fold"
  }, [(_vm.process !== 'next_actions') ? _c('div', {
    staticClass: "portlet light bordered"
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("\n\t\t\t\tManage Locations for "), _c('b', [_vm._v(_vm._s(_vm.editingRegion.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body portlet-overflow"
  }, [_c('div', {
    staticClass: "margin-top-20 row search-content-4"
  }, [_c('div', {
    staticClass: "search-table table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-condensed"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.editingRegion.locations), function(location) {
    return _c('tr', [_c('td', [_c('h4', [_vm._v(_vm._s(location.name))])]), _vm._v(" "), _c('td')])
  }))])])])])]) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_c('a', {
    staticClass: "no-click font-grey-mint"
  }, [_vm._v("Location Name")])]), _vm._v(" "), _c('th', [_c('a', {
    staticClass: "no-click font-grey-mint"
  }, [_vm._v("Actions")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e410eb2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/MyBusiness/Regions/ManageLocations.vue
// module id = 428
// module chunks = 1